export default function (data, parent) {
  var self = this;
  var r = Kadenze.Util.objFromString;

  self.id = ko.observable(r(data, 'id', null));
  self.coursework_id = ko.computed(function() {
    return r(data, 'coursework_id', parent.coursework_id());
  });
  self.coursework_field_id = ko.observable(r(data, 'coursework_field_id', null));
  self.name = ko.computed(function() {
    return parent.name();
  });
  self.points = ko.observable(r(data, 'points', parent._type() == 'WrittenResponseField' ? 10 : 1));
  self.weight = ko.observable(r(data, 'weight', 1));
  self.extra_credit = ko.computed(function() {
    return parent.extra_credit();
  });

  //Make sure extra credit question doesn't weight more than the entire coursework
  if (self.extra_credit() && parent.coursework_points() > 0)
    self.points.extend({ max: parent.coursework_points() });

  self.validate = function() {
    var propsToValidate = [];
    _.each(Object.getOwnPropertyNames(self), function(key) {
      if (ko.isObservable(self[key])) {
        propsToValidate.push(self[key]);
      }
    });
    var errors = ko.validation.group(propsToValidate, {deep: true});
    errors.showAllMessages(true);
    return errors();
  };

  self.isValid = function () {
    return self.validate().length == 0;
  };
}

